import React, {useRef} from "react";
import Icon from "sulu-admin-bundle/components/Icon";
import { PC_CORNERGOAL_TYPES } from "./params";

const TypeOfEventType = ({
  GOAL_TYPES,
  eventDetails,
  setEventDetails,
  changeCallback,
  confirmCallback,
  psEventActive,
  pcEventActive,
  editModal,
  allowChange = false
}) => {
  
    if(psEventActive || pcEventActive) {
        const isFirstRun = useRef(true);
        if(isFirstRun.current) {
          let goalType = '';
          if (pcEventActive) {
            goalType = PC_CORNERGOAL_TYPES.find(type => type.name === 'Penalty Corner');
          } else {
            goalType = GOAL_TYPES.find(type => type.name === '7 Meter');
          }
            isFirstRun.current = false;
            setEventDetails((data) => ({
                ...data,
                typeOfEventTypeSelected: goalType
            }));
        }
    }

    const isFeld = eventDetails?.type?.name === 'GOAL' && (!psEventActive && !editModal && !pcEventActive);
    if(isFeld && !editModal) {
        const isFirstRun = useRef(true);
        if(isFirstRun.current) {
            const goalType = GOAL_TYPES.find(type => type.name === 'Feld');
            isFirstRun.current = false;
            setEventDetails((data) => ({
                ...data,
                typeOfEventTypeSelected: goalType
            }));
            confirmCallback && confirmCallback();
        }
    }
  return (
    <div
      style={{
        padding: "10px 30px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{
          borderRadius: "50%",
          backgroundColor: "transparent",
          border: "1px solid black",
          height: 35,
          width: 35,
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: 20,
        }}
      >
        <Icon name="fa-arrow-circle-right" />
      </div>

      {eventDetails?.typeOfEventTypeSelected && (
        <button
          style={{
            borderRadius: 5,
            backgroundColor:
              eventDetails?.typeOfEventTypeSelected?.backgroundColor || "white",
            border: `2px solid ${eventDetails?.typeOfEventTypeSelected?.borderColor}`,
            color: eventDetails?.typeOfEventTypeSelected?.color || "black",
            height: 40,
            width: "25%",
            fontWeight: 700,
            marginRight: 30,
            fontSize: 13,
          }}
        >
          <span>{eventDetails?.typeOfEventTypeSelected?.name}</span>
        </button>
      )}

        {eventDetails?.typeOfEventTypeSelected && allowChange ? (
            <button
                style={{
                    border: "none",
                    backgroundColor: "transparent",
                    fontSize: "16px",
                }}
                onClick={() => {
                    setEventDetails((data) => ({
                        ...data,
                        typeOfEventTypeSelected: null,
                        typeOfCornerGoalSelected: null,
                    }));
                    changeCallback && changeCallback();
                }}
            >
                X
                <span
                    style={{
                        border: "none",
                        backgroundColor: "transparent",
                        fontSize: "16px",
                        textDecoration: "underline",
                        marginLeft: 5,
                    }}
                >
            Ändern
          </span>
            </button>
        ) : null}

      {!eventDetails?.typeOfEventTypeSelected && !psEventActive && !pcEventActive ? (
        <div
          style={{
            display: "flex",
            width: "70%",
          }}
        >
          {GOAL_TYPES?.map((tg, index) => {
            return (
              <button
                key={index}
                style={{
                  borderRadius: 5,
                  backgroundColor: tg?.backgroundColor || "white",
                  border: `2px solid ${tg?.borderColor}`,
                  color: tg?.color || "black",
                  height: 40,
                  width: "45%",
                  fontWeight: 700,
                  marginRight: 10,
                  fontSize: 13,
                }}
                onClick={() => {
                  setEventDetails((data) => ({
                    ...data,
                    typeOfEventTypeSelected: tg,
                  }));
                  const checkIfPcMiss = tg.name === 'Daneben';
                  confirmCallback && confirmCallback(checkIfPcMiss);
                }}
              >
                {tg?.name}
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default TypeOfEventType;
